<template>
	<router-view v-slot="{ Component, route }">
		<transition name="fade" mode="out-in">
			<component :is="Component" :key="route.path" />
		</transition>
	</router-view>
</template>
<script setup>
import { onMounted } from 'vue';
onMounted(() => {
});
</script>

<style>
.fade-enter-active {
	transition: all 0.6s ease-out;
}

.fade-leave-active {
	transition: all 0.6s ease-out;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

.van-picker__toolbar{
	display: none !important;
}
.van-picker-column__item--selected{
	color: #222 !important;
	font-weight: bold !important;
}
</style>
